import { CONSTANT } from '../../../constant/constant';
import { ENDPOINTS } from '../../../constant/endpoints';
import {
    generalHttpGetRequest,
    generalHttpPostRequest,
    generalHttpPutRequest
} from '../../../helper/request-helper';

const fetchClassUrl = CONSTANT.baseUrl + ENDPOINTS.employee.classes.fetchClass;
const searchClassesUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.classes.searchClasses;
const fetchClassFilingsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.classes.fetchClassFilings;
const fetchClassHistoryUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.classes.fetchClassHistory;
const fetchClassesByPortfolioUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.classes.fetchClassesByPortfolio;
const addEditNewClassUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.classes.addEditNewClass;
const fetchSalesUrl = CONSTANT.baseUrl + ENDPOINTS.employee.sales.fetchSales;
const fetchAdminSalesUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.sales.fetchAdminSales;

export const actionType = {
    REQUESTED_CLASSES_DATA: 'REQUESTED_CLASSES_DATA',
    REJECTED_CLASSES_DATA: 'REJECTED_CLASSES_DATA',
    FETCH_CLASSES_BY_PORTFOLIO: 'FETCH_CLASSES_BY_PORTFOLIO',
    EDIT_CLASS: 'EDIT_CLASS',
    FETCH_CLASS: 'FETCH_CLASS',
    FETCH_CLASS_BY_ID: 'FETCH_CLASS_BY_ID',
    SEARCH_CLASSES: 'SEARCH_CLASSES',
    CLEAR_SEARCH_CLASS_RESULTS: 'CLEAR_SEARCH_CLASS_RESULTS',
    FETCH_CLASS_FILINGS: 'FETCH_CLASS_FILINGS',
    FETCH_CLASS_HISTORY: 'FETCH_CLASS_HISTORY',
    UPDATE_EDIT_CLASS_PAYLOAD: 'UPDATE_EDIT_CLASS_PAYLOAD',
    ADD_NEW_CLASS: 'ADD_NEW_CLASS',
    UPDATE_ADD_NEW_CLASS_PAYLOAD: 'UPDATE_ADD_NEW_CLASS_PAYLOAD',
    UPDATE_CLASS_HISTORY_ITEM_SELECTED: 'UPDATE_CLASS_HISTORY_ITEM_SELECTED',
    HANDLE_ADD_CLASS_VISIBILITY: 'HANDLE_ADD_CLASS_VISIBILITY',
    HANDLE_EDIT_CLASS_VISIBILITY: 'HANDLE_EDIT_CLASS_VISIBILITY',
    HANDLE_VIEW_CLASS_VISIBILITY: 'HANDLE_VIEW_CLASS_VISIBILITY',
    FETCH_CLASS_SALES: 'FETCH_CLASS_SALES',
    FETCH_CLASS_ADMIN_SALES: 'FETCH_CLASS_ADMIN_SALES',
    CLEAR_CLASSES_LIST: 'CLEAR_CLASSES_LIST'
};

export const fetchClassData = (classId, parentPortfolios) => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLASSES_DATA
        });

        return generalHttpGetRequest(fetchClassUrl + classId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CLASS,
                    payload: response.data,
                    parentPortfolios: parentPortfolios
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLASSES_DATA,
                    data: error
                });
            });
    };
};

export const fetchClassById = classId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLASSES_DATA
        });

        return generalHttpGetRequest(fetchClassUrl + classId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CLASS_BY_ID,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLASSES_DATA,
                    data: error
                });
            });
    };
};

export const fetchClassFilings = classId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLASSES_DATA
        });

        return generalHttpGetRequest(fetchClassFilingsUrl + classId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CLASS_FILINGS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLASSES_DATA,
                    data: error
                });
            });
    };
};

export const fetchClassSales = params => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLASSES_DATA
        });

        return generalHttpGetRequest(fetchSalesUrl, params)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CLASS_SALES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLASSES_DATA,
                    data: error
                });
            });
    };
};

export const fetchClassAdminSales = params => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLASSES_DATA
        });

        return generalHttpGetRequest(fetchAdminSalesUrl, params)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CLASS_ADMIN_SALES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLASSES_DATA,
                    data: error
                });
            });
    };
};

export const fetchClassHistory = classId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLASSES_DATA
        });

        return generalHttpGetRequest(fetchClassHistoryUrl + classId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CLASS_HISTORY,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLASSES_DATA,
                    data: error
                });
            });
    };
};

export const fetchClassesByPortfolio = portfolioId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLASSES_DATA
        });

        return generalHttpGetRequest(fetchClassesByPortfolioUrl + portfolioId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CLASSES_BY_PORTFOLIO,
                    payload: response.data,
                    portfolioId: portfolioId
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLASSES_DATA,
                    data: error
                });
            });
    };
};

export const searchClasses = (searchPhrase, clientId) => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLASSES_DATA
        });

        return generalHttpGetRequest(
            searchClassesUrl + searchPhrase,
            { clientId: clientId },
            true
        )
            .then(response => {
                dispatch({
                    type: actionType.SEARCH_CLASSES,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLASSES_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const clearSearchClassResults = () => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_SEARCH_CLASS_RESULTS
        });
    };
};
export const addNewClass = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLASSES_DATA
        });

        return generalHttpPostRequest(addEditNewClassUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.ADD_NEW_CLASS,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLASSES_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const editClass = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLASSES_DATA
        });

        return generalHttpPutRequest(addEditNewClassUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.EDIT_CLASS,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLASSES_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const updateAddNewClassPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_ADD_NEW_CLASS_PAYLOAD,
            payload: selected
        });
    };
};

export const updateClassHistoryItemSelected = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_CLASS_HISTORY_ITEM_SELECTED,
            payload: selected
        });
    };
};

export const updateEditClassPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_EDIT_CLASS_PAYLOAD,
            payload: selected
        });
    };
};

export const clearClassesList = () => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_CLASSES_LIST
        });
    };
};

export const handleAddClassVisibility = visibility => {
    return dispatch => {
        dispatch({
            type: actionType.HANDLE_ADD_CLASS_VISIBILITY,
            visibility: visibility
        });
    };
};

export const handleEditClassVisibility = visibility => {
    return dispatch => {
        dispatch({
            type: actionType.HANDLE_EDIT_CLASS_VISIBILITY,
            visibility: visibility
        });
    };
};

export const handleViewClassVisibility = visibility => {
    return dispatch => {
        dispatch({
            type: actionType.HANDLE_VIEW_CLASS_VISIBILITY,
            visibility: visibility
        });
    };
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/classes/actions.js